import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, FormGroup, SimpleAlert } from 'twyne-new.ui';
import { isEqual } from 'lodash';

import siteStore from 'modules/admin/stores/site';
import Input from 'components/formsy/Input';
import { FormFragment } from 'components/formsy/FormComponent';
import { Loader2, Play } from 'lucide-react';

const propTypes = {
  partner: PropTypes.string,
  credentials: PropTypes.object
};

export default function APIChecker({ partner, credentials }) {
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState(null)
  const [looksGood, setLooksGood] = useState(false)
  const [needTest, setNeedTest] = useState(true)
  
  const initialCredentials = useMemo(() => credentials, [])
  
  const handleFeedback = (ok) => {
    setLooksGood(ok)
    setFeedback(ok)
    setTimeout(() => setFeedback(null), 3000)
  }

  useEffect(() => {
    setNeedTest(!isEqual(initialCredentials, credentials))
    setLooksGood(false)
  }, Object.values(credentials))

  const handleClick = async () => {
    setLoading(true)
    try {
      const ok = await siteStore.checkPartner({ partner, credentials })
      handleFeedback(!!ok)
    } catch (e) {
      handleFeedback(false)
    }
    setLoading(false)
  }

  return <Row className='mt-4'>
    <Col size="12">
      <FormGroup>
        <Button className='w-fit' color='accent' onClick={handleClick}>
          {loading ? <Loader2 size={14} className='animate-spin' /> : <Play size={14} />}
          {loading ? 'Testing...' : 'Test'}
        </Button>
        <FormFragment name='$tested' back={2}>
          <Input type='hidden' name={partner} value={looksGood}
            validations={{
              isTested: ({ [`$needTest[${partner}]`]: $needTest }, tested) => {
                return tested || !($needTest || needTest)
              }
            }}
            validationErrors={{
              isTested: "Please, test these credentials before save."
            }} />
        </FormFragment>
      </FormGroup>
    </Col>
    {!loading && [true, false].includes(feedback) && <>
      <Col size='6'>
        <FormGroup>
          {!loading && feedback === true ? <SimpleAlert isOpen={true} variant='success'>Looks good!</SimpleAlert> : null}
          {!loading && feedback === false ? <SimpleAlert isOpen={true} variant='danger'>These credentials appears to be invalid</SimpleAlert> : null}
        </FormGroup>
      </Col>
    </>}
  </Row>
}

APIChecker.propTypes = propTypes
APIChecker.defaultProps = {}